import { useEffect, useState } from 'react';

type PaginationProps = {
  onPageClick: (page: number) => void;
  page: number;
  totalCount: number;
  count: number;
};
type PageInfo = {
  pageNumber: number;
  name: string;
};

export default function Pagination({
  onPageClick,
  page,
  totalCount,
  count,
}: PaginationProps) {
  const [pageList, setPageList] = useState<PageInfo[]>([]);

  const generatePagination = (
    curPage: number,
    totalCnt: number,
    cnt: number,
  ) => {
    const pages: PageInfo[] = [];
    const pageCntShow = 10;

    const pageCntTotal = Math.ceil(totalCnt / cnt);
    const startPage = Math.floor((curPage - 1) / pageCntShow) * pageCntShow + 1;
    const endPage = Math.min(pageCntTotal, startPage + pageCntShow - 1);

    if (startPage > pageCntShow) {
      pages.push({ pageNumber: 1, name: 'first' });
      pages.push({ pageNumber: startPage - pageCntShow, name: 'prev' });
    }

    for (let i = startPage; i <= endPage; i += 1) {
      pages.push({ pageNumber: i, name: i.toString() });
    }

    if (endPage < pageCntTotal) {
      pages.push({ pageNumber: startPage + pageCntShow, name: 'next' });
      pages.push({ pageNumber: pageCntTotal, name: 'last' });
    }

    setPageList(pages);
  };

  useEffect(() => {
    generatePagination(page, totalCount, count);
  }, [page, totalCount, count]);

  const iClass = (name: string): string | null => {
    switch (name) {
      case 'first':
        return 'first';
      case 'prev':
        return 'prev';
      case 'next':
        return 'next';
      case 'last':
        return 'last';
      default:
        return null;
    }
  };

  const pageListComponent = pageList.map((item) => (
    <li
      key={item.pageNumber}
      className={`${page === item.pageNumber ? 'on' : ''}`}
    >
      {!iClass(item.name) && (
        <button type={'button'} onClick={() => onPageClick(item.pageNumber)}>
          {item.name}
        </button>
      )}
      {iClass(item.name) && (
        <button
          type={'button'}
          onClick={() => onPageClick(item.pageNumber)}
          className={item.name}
        >
          {''}
        </button>
      )}
    </li>
  ));

  return (
    <div className={'paging'}>
      <ul>{pageListComponent}</ul>
    </div>
  );
}
